import { getAssetPath } from '@/constants/configs';
import {
  defaultConfigs,
  getExtraBasicInfoQuestions as defaultGetExtraBasicInfoQuestions,
  resolveICBWebUrl,
} from '@/constants/tenant-configs/default';

import { QuestionCode } from '@/types/api/pep';
import { AppConfigurations } from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { Profession, User } from '@/types/user';

import { isBusinessPurposeQuestionEnabled, isMinorUser } from '@/utils/user';

export const dominicaConfigs: AppConfigurations = {
  ...defaultConfigs,
  links: {
    ...defaultConfigs.links,
    privacyPolicyURL:
      'https://www.republicbankdominica.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://republiconline.republictt.com/dm/legal.html',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-dma.pdf'),
    appTermsAndConditionsURL: getAssetPath('/tnc/republiconboard-tnc-dma.pdf'),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-dma.pdf',
    ),
    icbWeb: resolveICBWebUrl(
      'https://republiconlineec.rfhl.com/RBEC.UI/#/administrationGeneral/login',
    ),
    icbIOS: 'https://apps.apple.com/us/app/republicmobile-ec/id1582093121',
    icbAndroid:
      'https://play.google.com/store/apps/details?id=ecicprod.com.republicapp',
    eFreeURL: 'https://www.republicbankdominica.com/personal/e-free-account',
    savingsPlusURL:
      'https://www.republicbankdominica.com/personal/savings-plus-account',
  },
  defaultCountryCode: '1264',
  locale: 'en-DM',
  isoCode: 'DMA',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'XCD',
  idCaptureRequirement: 'idCardOrPassport',
  idDocumentTypes: [DocumentType.Passport, DocumentType.IdentityDriverLicense],
  showRiskSectorFlagQuestion: false,
  showSelfEmployedWithRiskSectorFlagQuestion: true,
  existingCustomer: {
    maxAccountsPerType: 2,
  },
  autoApproveUnemployedProfessions: [
    Profession.Pensioner,
    Profession.Housewife,
    Profession.Unemployed,
  ],
  jointAccountRelationshipOptions: [
    { value: 'PARENT', i18nKey: 'minorOthers.form.relationship.parent' },
    {
      value: 'LEGAL_GUARDIAN',
      i18nKey: 'minorOthers.form.relationship.legalGuardian',
    },
  ],
};

export const getExtraBasicInfoQuestions = (user: User) => {
  if (isMinorUser(user)) {
    return defaultGetExtraBasicInfoQuestions(user);
  }
  return {
    ...defaultGetExtraBasicInfoQuestions(user),
    [QuestionCode.AccountPurpose]: {
      enabled: isBusinessPurposeQuestionEnabled(user),
      question: 'questionDrawer.accountPurpose.question',
      priority: 0,
    },
  };
};
